module.exports = __webpack_public_path__ + "img/carshina21_14.f70590b0.jpg";